// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__AuwFM","head":"ProcedureTableInfo_head__2hPEQ"};